var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Keycloak from 'keycloak-js';
import defaultsDeep from 'lodash.defaultsdeep';
import throttle from 'lodash.throttle';
import { autobind, loggedIn, } from './decorators';
import { extractResourceOwner } from './utils';
import { AuthInitError, AuthTimeoutError } from './errors';
const silentCheckSsoRedirectUri = `${window.location.origin}/.well-known/openid-silent-check-sso.html`;
export const defaultOptions = {
    config: {
        realm: '',
        clientId: '',
        url: '',
    },
    init: {
        onFailureRedirectURL: 'https://www.storebrand.no/infosider/driftsmelding-kc',
        silentCheckSsoRedirectUri,
        checkLoginIframe: true,
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        scope: '',
    },
    login: {
        scope: '',
        allowedACR: [],
        allowedAMR: [],
        timeout: 5000,
    },
    logout: {
        redirectUri: `${window.location.origin}/logg-ut/`,
    },
    windowProp: 'stbauth',
    autoRefresh: false,
};
/**
 * Idea: Make the base keycloak-js library better
 * fit for Storebrand's frontend clients.
 *
 * Patterns used: [Adapter, Decorator]
 */
let AuthClient = (() => {
    var _a, _AuthClient_keycloak, _AuthClient_options;
    let _instanceExtraInitializers = [];
    let _init_decorators;
    let _login_decorators;
    let _get_needStepUp_decorators;
    let _stepUp_decorators;
    let _logout_decorators;
    let _getToken_decorators;
    let _get_canStepUp_decorators;
    let _get_idTokenParsed_decorators;
    let _get_sub_decorators;
    let _get_nin_decorators;
    return _a = class AuthClient {
            constructor(options) {
                _AuthClient_keycloak.set(this, __runInitializers(this, _instanceExtraInitializers));
                _AuthClient_options.set(this, void 0);
                __classPrivateFieldSet(this, _AuthClient_options, defaultsDeep(options, defaultOptions), "f");
                __classPrivateFieldSet(this, _AuthClient_keycloak, new Keycloak(__classPrivateFieldGet(this, _AuthClient_options, "f").config), "f");
                const { windowProp, logout } = this.options;
                const { onAuthLogout } = logout;
                __classPrivateFieldGet(this, _AuthClient_keycloak, "f").onAuthLogout = () => {
                    if (onAuthLogout) {
                        onAuthLogout();
                    }
                    else {
                        window.location.reload();
                    }
                };
                if (windowProp) {
                    window[windowProp] = this;
                }
            }
            get instance() {
                return __classPrivateFieldGet(this, _AuthClient_keycloak, "f");
            }
            get options() {
                return __classPrivateFieldGet(this, _AuthClient_options, "f");
            }
            refreshTokenOnActivity() {
                const { iat, exp } = this.instance.refreshTokenParsed;
                const REFRESH_DURATION_MS = ((exp - iat) / 2) * 1000;
                const throttledRefresh = throttle(() => {
                    console.log('Refreshing token due to user activity!');
                    this.instance.updateToken(30).catch((e) => console.error("Couldn't update token", e));
                }, REFRESH_DURATION_MS, { leading: true, trailing: false });
                document.addEventListener('mousemove', throttledRefresh);
                document.addEventListener('keypress', throttledRefresh);
                document.addEventListener('scroll', throttledRefresh);
            }
            static encode(values) {
                return encodeURIComponent(values.join(' '));
            }
            init() {
                return __awaiter(this, arguments, void 0, function* (initOptions = this.options.init) {
                    const { onFailureRedirectURL } = initOptions, nativeInitOptions = __rest(initOptions, ["onFailureRedirectURL"]);
                    try {
                        const authenticated = yield this.instance.init(nativeInitOptions);
                        const { autoRefresh } = this.options;
                        if (authenticated) {
                            if (this.needStepUp) {
                                yield this.stepUp();
                            }
                            if (autoRefresh) {
                                this.refreshTokenOnActivity();
                            }
                        }
                        return authenticated;
                    }
                    catch (error) {
                        if (onFailureRedirectURL) {
                            const searchParams = new URLSearchParams([
                                ['error', JSON.stringify(error)],
                                ['client_id', this.options.config.clientId],
                            ]);
                            const redirectUrl = new URL(onFailureRedirectURL);
                            redirectUrl.search = searchParams.toString();
                            window.location.replace(redirectUrl);
                        }
                        throw new AuthInitError({ cause: error });
                    }
                });
            }
            createLoginUrl(loginOptions = this.options.login) {
                const { allowedACR, allowedAMR, stbIdpHints, showExtraIdpList } = loginOptions, nativeLoginOptions = __rest(loginOptions, ["allowedACR", "allowedAMR", "stbIdpHints", "showExtraIdpList"]);
                const defaultURL = __classPrivateFieldGet(this, _AuthClient_keycloak, "f").createLoginUrl(nativeLoginOptions);
                let hintsURLParam = '';
                if (stbIdpHints === null || stbIdpHints === void 0 ? void 0 : stbIdpHints.length) {
                    hintsURLParam = `&stb_idp_hints=${_a.encode(stbIdpHints)}`;
                }
                let acrURLParam = '';
                if (allowedACR === null || allowedACR === void 0 ? void 0 : allowedACR.length) {
                    acrURLParam = `&acr_values=${_a.encode(allowedACR)}`;
                }
                let amrURLParam = '';
                if (allowedAMR === null || allowedAMR === void 0 ? void 0 : allowedAMR.length) {
                    amrURLParam = `&amr_values=${_a.encode(allowedAMR)}`;
                }
                const extraIdp = showExtraIdpList
                    ? '#login-extra-idp-list'
                    : '';
                return `${defaultURL}${hintsURLParam}${acrURLParam}${amrURLParam}${extraIdp}`;
            }
            login() {
                return __awaiter(this, arguments, void 0, function* (loginOptions = this.options.login, timeout = 5000) {
                    if (this.authenticated) {
                        const resourceOwnerFromScope = extractResourceOwner(loginOptions.scope);
                        if (!resourceOwnerFromScope) {
                            return Promise.resolve();
                        }
                        const resourceOwnerFromToken = this.authenticatedOnBehalfOf;
                        if (resourceOwnerFromScope === resourceOwnerFromToken) {
                            return Promise.resolve();
                        }
                    }
                    const loginUrl = this.createLoginUrl(loginOptions);
                    window.location.assign(loginUrl);
                    return new Promise((_, reject) => {
                        setTimeout(() => {
                            reject(new AuthTimeoutError());
                        }, timeout);
                    });
                });
            }
            /**
             * If no allowedACR or allowedAMR is set, return false
             * If acr is present in allowedACR or amr is present in allowedAMR, return false
             * otherwise return true
            */
            get needStepUp() {
                var _b, _c;
                const { acr, amr } = this.idTokenParsed;
                const { allowedACR, allowedAMR } = this.options.login;
                /** if both allowedACR and allowedAMR are empty */
                if ((!allowedACR || allowedACR.length === 0)
                    && (!allowedAMR || allowedAMR.length === 0)) {
                    return false;
                }
                const hasTokenAllowedACR = (_b = allowedACR === null || allowedACR === void 0 ? void 0 : allowedACR.includes(acr)) !== null && _b !== void 0 ? _b : false;
                const hasTokenAllowedAMR = (_c = allowedAMR === null || allowedAMR === void 0 ? void 0 : allowedAMR.includes(amr)) !== null && _c !== void 0 ? _c : false;
                /** if token contains either allowed ACR or allowed AMR */
                if (hasTokenAllowedACR || hasTokenAllowedAMR) {
                    return false;
                }
                /** already as secure as possible */
                if (!this.canStepUp) {
                    return false;
                }
                return true;
            }
            stepUp() {
                return __awaiter(this, arguments, void 0, function* (loginOptions = this.options.login) {
                    const loginUrl = this.createLoginUrl(Object.assign({ prompt: 'login' }, loginOptions));
                    window.location.assign(loginUrl);
                    /**
                     * This suspended promise is to ensure that this function does not
                     * resolve before the app has redirected to the login page.
                     */
                    return Promise.resolve();
                });
            }
            logout() {
                return __awaiter(this, arguments, void 0, function* (logoutOptions = this.options.logout) {
                    return this.instance.logout(logoutOptions);
                });
            }
            /**
             * Potentially rename this to getUpdatedToken
             * because you aren't getting the same token
             * every time you call this method.
             */
            getToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!this.authenticated) {
                        return Promise.resolve('');
                    }
                    return __classPrivateFieldGet(this, _AuthClient_keycloak, "f").updateToken(30).then(() => __classPrivateFieldGet(this, _AuthClient_keycloak, "f").token);
                });
            }
            get authenticated() {
                return !!__classPrivateFieldGet(this, _AuthClient_keycloak, "f").authenticated;
            }
            get authenticatedOnBehalfOf() {
                var _b, _c;
                if (!this.authenticated) {
                    return null;
                }
                const resourceOwnerFromToken = (_b = this.idTokenParsed.on_behalf_of) === null || _b === void 0 ? void 0 : _b.resource_owner;
                if (resourceOwnerFromToken) {
                    return resourceOwnerFromToken;
                }
                const onBehalfOfFromToken = (_c = this.advisor.on_behalf_of) === null || _c === void 0 ? void 0 : _c.cm_id;
                if (onBehalfOfFromToken) {
                    return `cm_id:${onBehalfOfFromToken}`;
                }
                return null;
            }
            get canStepUp() {
                var _b;
                return !((_b = this.idTokenParsed.acr) === null || _b === void 0 ? void 0 : _b.includes('al4'));
            }
            get idTokenParsed() {
                return __classPrivateFieldGet(this, _AuthClient_keycloak, "f").idTokenParsed;
            }
            get sub() {
                return this.idTokenParsed.sub;
            }
            get nin() {
                return this.idTokenParsed.no_nin;
            }
            get advisor() {
                return this.instance.tokenParsed;
            }
        },
        _AuthClient_keycloak = new WeakMap(),
        _AuthClient_options = new WeakMap(),
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _init_decorators = [autobind];
            _login_decorators = [autobind];
            _get_needStepUp_decorators = [loggedIn];
            _stepUp_decorators = [loggedIn, autobind];
            _logout_decorators = [autobind];
            _getToken_decorators = [autobind];
            _get_canStepUp_decorators = [loggedIn];
            _get_idTokenParsed_decorators = [loggedIn];
            _get_sub_decorators = [loggedIn];
            _get_nin_decorators = [loggedIn];
            __esDecorate(_a, null, _init_decorators, { kind: "method", name: "init", static: false, private: false, access: { has: obj => "init" in obj, get: obj => obj.init }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _login_decorators, { kind: "method", name: "login", static: false, private: false, access: { has: obj => "login" in obj, get: obj => obj.login }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_needStepUp_decorators, { kind: "getter", name: "needStepUp", static: false, private: false, access: { has: obj => "needStepUp" in obj, get: obj => obj.needStepUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _stepUp_decorators, { kind: "method", name: "stepUp", static: false, private: false, access: { has: obj => "stepUp" in obj, get: obj => obj.stepUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _logout_decorators, { kind: "method", name: "logout", static: false, private: false, access: { has: obj => "logout" in obj, get: obj => obj.logout }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _getToken_decorators, { kind: "method", name: "getToken", static: false, private: false, access: { has: obj => "getToken" in obj, get: obj => obj.getToken }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_canStepUp_decorators, { kind: "getter", name: "canStepUp", static: false, private: false, access: { has: obj => "canStepUp" in obj, get: obj => obj.canStepUp }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_idTokenParsed_decorators, { kind: "getter", name: "idTokenParsed", static: false, private: false, access: { has: obj => "idTokenParsed" in obj, get: obj => obj.idTokenParsed }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_sub_decorators, { kind: "getter", name: "sub", static: false, private: false, access: { has: obj => "sub" in obj, get: obj => obj.sub }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_nin_decorators, { kind: "getter", name: "nin", static: false, private: false, access: { has: obj => "nin" in obj, get: obj => obj.nin }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export default AuthClient;
